import QRCode from "qrcode";
import Remove from "@/views/MGT/Corpcircle/modal/remove";
export default {
  name: "cor-detail",
  components: {
    Remove
  },
  data() {
    return {
      remove: {
        visible: false
      }
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    setQr() {
      let qrCode = "https://www.pmdaniu.com/clouds/126612/516df3298ce6641d9c1e969ceeaceddc-18112/start.html#id=33izsp&p=%E8%AF%A6%E6%83%85&g=1";
      QRCode.toCanvas(document.getElementById("qrcode_corpcircle_canvas"), qrCode, {
        width: 150
      });
    },
    copy() {
      console.log("copy");
    },
    resetQr() {
      console.log("resetQr");
    },
    openModal(key) {
      switch (key) {
        case "remove":
          this.remove.visible = true;
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.setQr();
  }
};